import React, { useState, useEffect } from "react";

import UserService from "../services/user.service";
import TablaCC from "./TablaCC";

import EventBus from "../common/EventBus";

import Alert from "react-bootstrap/Alert";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const BoardModerator = () => {
  const [content, setContent] = useState("");
  const [permisoVerCuentaCorriente, setPermisoVerCuentaCorriente] =
    useState(false);
  const [permisoChequeado, setPermisoChequeado] = useState(false);

  useEffect(() => {
    const userCrudo = localStorage.getItem("user");
    const user = userCrudo ? JSON.parse(userCrudo) : null;
    const permiso = Array.isArray(user?.permisos)
      ? user.permisos.find(
          (permiso) =>
            permiso?.Denominacion?.trim().toLowerCase() ===
            "ver cuenta corriente"
        )
      : null;
    const tienePermiso = Number(permiso?.Habilitado) === 1;

    setPermisoVerCuentaCorriente(tienePermiso);
    setPermisoChequeado(true);

    if (!tienePermiso) {
      return;
    }

    UserService.getModeratorBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  }, []);

  return (
    <div className="container" style={{ paddingTop: 24, paddingBottom: 24 }}>
      <div
        style={{
          backgroundColor: "#F9F2ED",
          borderRadius: 12,
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.12)",
          overflow: "hidden",
        }}
      >
        <div style={{ padding: "24px 24px 8px" }}>
          <h3 style={{ color: "#2f2f2f", marginBottom: 20 }}>
            Cuentas Corrientes
          </h3>
        </div>
        {!permisoChequeado ? null : permisoVerCuentaCorriente ? (
          content !== undefined && content !== "No token provided!" ? (
            <div style={{ padding: "0 8px 16px" }}>
              <Tabs
                defaultActiveKey="todas"
                id="uncontrolled-tab-example"
                className="mb-3"
                onSelect={(k) => console.log("K:" + k)}
              >
                <Tab eventKey="todas" title="Todas">
                  <TablaCC>{0}</TablaCC>
                </Tab>
                <Tab eventKey="deudores" title="Deudores">
                  <TablaCC>{1}</TablaCC>
                </Tab>
                <Tab eventKey="atrasados" title="Atrasados">
                  <TablaCC>{2}</TablaCC>
                </Tab>
              </Tabs>
            </div>
          ) : null
        ) : (
          <div style={{ padding: "0 24px 24px" }}>
            <Alert
              variant="warning"
              style={{
                marginBottom: 0,
                backgroundColor: "#FFF3CD",
                borderColor: "#FFDA6A",
                color: "#664D03",
              }}
            >
              <Alert.Heading>Acceso denegado</Alert.Heading>
              <p className="mb-0">
                No tiene el permiso adecuado para ver cuenta corriente.
              </p>
            </Alert>
          </div>
        )}
      </div>
    </div>
  );
};

export default BoardModerator;
